import React, { Component } from "react";
import { Line as LineChart } from "react-chartjs";
import "./App.css";

const options = {
    legend: {
        display: true,
        labels: {
            fontColor: "#fff"
        }
    },
    scales: {
        yAxes: [{
            ticks: {
                beginAtZero: true
            }
        }]
    },
    tooltips: {
        callbacks: {
            label: function(tooltipItem, data) {
                var datasetLabel = data.datasets[tooltipItem.datasetIndex].label;
                var match = tooltipItem.yLabel.toString().match(/(\d+)(\.(0+)?(\d{0,2}))?/);
                return datasetLabel + ': ' + match[0];
            }
        }
    }
};

class Chart extends Component {
	render() {
        const data = {
            labels: [
                "1 Hour",
                "2 Hours",
                "3 Hours",
                "4 Hours",
                "5 Hours",
                "6 Hours"
            ],
            datasets: [{
                label: "Yellow Chips",
                data: this.props.yellowChips,
                backgroundColor: "transparent",
                borderColor: "#FFD600",
                borderWidth: 2
            }, {
                label: "Green Chips",
                data: this.props.greenChips,
                backgroundColor: "transparent",
                borderColor: "#64DD17",
                borderWidth: 2
            }, {
                label: "Red Chips",
                data: this.props.redChips,
                backgroundColor: "transparent",
                borderColor: "#D50000",
                borderWidth: 2
            }]
        };
		return (
			<div className="App">
				<LineChart data={data} options={options} />
			</div>
		);
	}
}

export default Chart;



// WEBPACK FOOTER //
// ./src/Chart.js